export default __webpack_public_path__ + "static/media/45.6b92d813.jpg";